import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NbButtonModule, NbIconModule, NbRadioModule } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';
import { RadiosInput } from './../../../models/inputs/radios-input';
import { BaseInputComponent } from './../base-input/base-input.component';

@Component({
	selector: 'app-radios-input',
	styles: [
		`
			nb-radio.inline {
				display: inline;
			}
		`
	],
	template: `
		<div class="d-block">
			<nb-radio-group
				[status]="control.colorStatus"
				[formControl]="control"
			>
				@for (option of control.options | async; track option) {
					<nb-radio
						[value]="option.value"
						[class.inline]="control.inline"
					>
						{{ option.label | translate }}
					</nb-radio>
				}
			</nb-radio-group>

			@if (control.clearable) {
				<button
					type="button"
					nbButton
					status="basic"
					size="small"
					(click)="control.reset()"
				>
					<nb-icon icon="close-outline"></nb-icon>
					{{ 'UTILS.CLEAR' | translate }}
				</button>
			}
		</div>
	`,
	standalone: true,
	imports: [
		NbRadioModule,
		ReactiveFormsModule,
		NbButtonModule,
		NbIconModule,
		AsyncPipe,
		TranslateModule
	]
})
export class RadiosInputComponent extends BaseInputComponent {
	@Input({ required: true }) control: RadiosInput;
}
